import React, { memo } from 'react'
import { Container, Row, Col, Card } from '@paypalcorp/pp-react'
import Section from '../../components/privacyHub/section'
import {
  constructConfigForSection,
  principlesConfig,
  directionality,
  homeConfig
} from '../../config/privacy-hub'
import PrivacyHubHeader from '../../components/privacyHub/privacy-hub-header'


const PrivacyPrinciplesSection = memo(() => {
  return (
    <>
      <Container className="privacy-hub-section-container">
        <div className="privacy-hub-wrapper">
        <PrivacyHubHeader {...homeConfig.headerSection('principles')}/>
        </div>
      </Container>
    </>
  )
})
PrivacyPrinciplesSection.displayName = 'PrivacyPrinciplesSection'

const PrivacyHubKeyTakeawaysSection = memo(() => (
  <Container className="privacy-hub-section-container">
    <div
      className={`privacy-hub-wrapper privacy-hub-main-links-wrapper ${directionality}`}
    >
      <Row className="main-links-row" noGutters>
        {principlesConfig.KeyTakeaways.map(
          ({ title, description, id, icon }, index) => (
            <Col
              className="privacy-hub-card-container"
              xs={12}
              md={6}
              key={index}
            >
              <Container fluid className="container-wrapper">
                <Section
                  {...constructConfigForSection('Main_Links', {
                    description: {
                      class: 'privacy-hub-text privacy-hub-description',
                      id: `${id}Desc`,
                      messageId: description,
                      size: 'sm',
                    },
                    heading: {
                      size: 'sm',
                      class: 'privacy-hub-text privacy-hub-link-title ',
                      id: `${id}Title`,
                      messageId: title,
                    },
                    component_icon: {
                      name: icon.name,
                      size: icon.size,
                      color: icon.color,
                      svgIconClass: icon.class,
                    },
                  })}
                />
              </Container>
            </Col>
          ),
        )}
      </Row>
    </div>
  </Container>
))
PrivacyHubKeyTakeawaysSection.displayName = 'PrivacyHubKeyTakeawaysSection'

const PrivacyHubHorizantalCardsSection = memo(() => (
  <Container className="privacy-hub-section-container">
    <div className="privacy-hub-wrapper privacy-hub-card-horizontal-cards-section">
      <Row className="row" noGutters>
        {principlesConfig.horizantalCardsConfig.map(
          ({ title, id, svg_icon }, index) => (
            <Card
              key={index}
              className={`privacy-hub-card privacy-hub-card-sm privacy-hub-display-col-mid ${
                index === principlesConfig?.horizantalCardsConfig?.length - 1 &&
                'privacy-hub-card-last'
              }`}
            >
              <Section
                {...constructConfigForSection('Card_section', {
                  description: {
                    class:
                      'privacy-hub-description privacy-hub-text text-center',
                    id,
                    messageId: title,
                    size: 'sm',
                  },
                  icon_svg_link: {
                    imgSrc: svg_icon.src,
                    imgClass: svg_icon.class,
                    alt: svg_icon.alt,
                  },
                })}
              />
            </Card>
          ),
        )}
      </Row>
    </div>
  </Container>
))
PrivacyHubHorizantalCardsSection.displayName =
  'PrivacyHubHorizantalCardsSection'

const PrivacyHubPrinciples = memo(() => (
  <div id="privacy-hub-principles">
    <PrivacyPrinciplesSection />
    <PrivacyHubHorizantalCardsSection />
    <PrivacyHubKeyTakeawaysSection />
  </div>
))

PrivacyHubPrinciples.displayName = 'PrivacyHubPrinciples'

export default PrivacyHubPrinciples
